import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { FormField, inputClass } from './FormField';
interface SelectFieldProps {
  id: string;
  label: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
  error?: string;
  className?: string;
}
export function SelectField({
  id,
  label,
  value,
  options,
  onChange,
  error,
  className
}: SelectFieldProps) {
  return <FormField label={label} htmlFor={id} error={error} className={className} data-id="element-344" data-mp="3nhohhvfoikls">
      <div className="relative" data-id="element-345" data-mp="3iqoov2dleop3">
        <select id={id} value={value} onChange={e => onChange(e.target.value)} className={`${inputClass} appearance-none pr-9`} data-id="element-346" data-mp="3ipdkb0cbpcwx">
          <option value="" data-id="element-347" data-mp="3drlldmd9gqj8">Seleccionar</option>
          {options.map(o => <option key={o} value={o} data-id="element-348" data-mp="39rbdg45wrq1q">
              {o}
            </option>)}
        </select>
        <ChevronDownIcon className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" aria-hidden="true" data-id="element-349" data-mp="34q4789jeyyx6" />
      </div>
    </FormField>;
}